import { useEffect, useRef } from "react";
import { toast } from "sonner";

const POLL_INTERVAL = 2 * 60 * 1000; // 2 minutes

export function useAppVersionCheck() {
  const hasNotified = useRef(false);

  useEffect(() => {
    if (__APP_BUILD_HASH__ === "dev") return;

    const currentHash = __APP_BUILD_HASH__;

    const check = async () => {
      try {
        const res = await fetch("/version.json", { cache: "no-store" });
        if (!res.ok) return;
        const data = await res.json();
        if (data.hash && data.hash !== currentHash && !hasNotified.current) {
          hasNotified.current = true;
          toast.info("A new version is available", {
            id: "app-version-update",
            description: "Refresh to get the latest features, fixes, and improvements to the app.",
            duration: Infinity,
            action: {
              label: "Refresh",
              onClick: () => window.location.reload(),
            },
          });
        }
      } catch {
        // Silently ignore - offline, network error, etc.
      }
    };

    const intervalId = setInterval(check, POLL_INTERVAL);
    return () => clearInterval(intervalId);
  }, []);
}
